
const port = {
  stock: '/p/cs/stock/200000244070', // 获取库存在用的公共接口
  matrix: '/api/cs/md/matrix', // 获取颜色尺寸的公共接口
  judgePro: '/api/cs/md/judgePro', // 判断是商品编码还是条码
  DL_B_PUR_ORDER: {
    getBody: '/api/cs/oc/oms/v1/getMatrixData', // 获取商品编码各个SKU数量（用于修改）
    amendBody: '/p/cs/objectSave', // 保存修改的商品编码各个SKU数量
    singleCode: '/p/cs/barcodeSave', // 单条码数量保存
    tableName: 'DL_B_PUR_ORDER_ITEM', // 子表表名
    queryObjSave: 'DL_B_PUR_ORDER_ITEM', // 左边列表保存字段名
    virtualName: 'DL_B_PUR_ORDER_ITEM_MATRIX', // 虚表表名
    hasMatch: false, // 是否有匹配矩阵
    matchData: {},
    isDeleteBtn: true, // 是否有删除明细按钮
    hasStock: false, // 不获取库存接口
    inputList: [{
      name: t('数量'),
      colname: 'QTY_BILL',
      defnum: 1
    }], // 配的数量字段名集合
    matrixInput: false, // 是否显示数量框
  }, // 采购订单
  DL_B_PUR_REQ: {
    getBody: '/api/cs/oc/oms/v1/getMatrixData', // 获取商品编码各个SKU数量（用于修改）
    amendBody: '/p/cs/objectSave', // 保存修改的商品编码各个SKU数量
    singleCode: '/p/cs/barcodeSave', // 单条码数量保存
    tableName: 'DL_B_PUR_REQ_ITEM', // 子表表名
    queryObjSave: 'DL_B_PUR_REQ_ITEM', // 左边列表保存字段名
    virtualName: 'DL_B_PUR_REQ_ITEM_V', // 虚表表名
    hasMatch: false, // 是否有匹配矩阵
    matchData: {},
    isDeleteBtn: true, // 是否有删除明细按钮
    hasStock: false, // 不获取库存接口
    inputList: [{
      name: t('数量'),
      colname: 'QTY_BILL',
      defnum: 1
    }], // 配的数量字段名集合
    matrixInput: false, // 是否显示数量框
  }, // 采购需求
  DL_B_PUR_IN: {
    getBody: '/api/cs/oc/oms/v1/getMatrixData', // 获取商品编码各个SKU数量（用于修改）
    amendBody: '/p/cs/objectSave', // 保存修改的商品编码各个SKU数量
    singleCode: '/p/cs/barcodeSave', // 单条码数量保存
    queryObjSave: 'PRICE_ACTUAL_LIST', // 左边列表保存字段名
    tableName: 'DL_B_PUR_IN_ITEM', // 子表表名
    virtualName: 'DL_B_PUR_IN_ITEM_MATRIX', // 虚表表名
    hasStock: true, // 获取库存接口
    matchData: {},
    hasMatch: false, // 是否有匹配矩阵
    isDeleteBtn: true, // 是否有删除明细按钮
    isStock: true, // 配置默认显示在库的还是可用的
    inputList: [{
      name: t('数量'),
      colname: 'QTY_BILL',
      defnum: 1
    }], // 配的数量字段名集合
    matrixInput: false, // 是否显示数量框
  }, // 采购入库
  DL_B_TRAN_OUT_POS: {
    getBody: '/api/cs/oc/oms/v1/getMatrixData', // 获取商品编码各个SKU数量（用于修改）
    amendBody: '/p/cs/objectSave', // 保存修改的商品编码各个SKU数量
    singleCode: '/p/cs/barcodeSave', // 单条码数量保存
    tableName: 'DL_B_TRAN_OUT_V_ITEM_PRO_POS', // 子表表名
    queryObjSave: 'DL_B_TRAN_OUT_V_ITEM_PRO_POS', // 左边列表保存字段名
    virtualName: 'DL_B_TRAN_OUT_V_ITEM_PRO_POS', // 虚表表名
    special: 'DL_B_TRAN_OUT_V_ITEM_SKU', // 特殊情况
    secondTab: 'DL_B_TRAN_OUT_V_ITEM_SKU', // input为配置时单条码和矩阵的保存fixcolumn里面的表名key
    matchData: {
      data: [{
        label: t('发货店仓'),
        value: 'qty_stock_able',
        port: 1, // 表示第一个接口
      },
        {
          label: t('收货仓库'),
          value: 'qty_stock_able',
          port: 2, // 表示第二个接口
        },
      ],
    }, // 匹配的一些参数
    hasMatch: true, // 是否有匹配矩阵
    hasStock: true, // 获取库存接口
    isStock: false, // 配置默认显示在库的还是可用的
    isDeleteBtn: true, // 是否有删除明细按钮
    inputList: [{
      name: t('数量'),
      colname: 'QTY_BILL',
      defnum: 1
    }], // 配的数量字段名集合
    matrixInput: false, // 是否显示数量框
  }, // pos端调拨出库单
  DL_B_TRAN_OUT: {
    getBody: '/api/cs/oc/oms/v1/getMatrixData', // 获取商品编码各个SKU数量（用于修改）
    amendBody: '/p/cs/objectSave', // 保存修改的商品编码各个SKU数量
    singleCode: '/p/cs/barcodeSave', // 单条码数量保存
    tableName: 'DL_B_TRAN_OUT_V_ITEM_PRO', // 子表表名
    queryObjSave: 'DL_B_TRAN_OUT_V_ITEM_PRO', // 左边列表保存字段名
    virtualName: 'DL_B_TRAN_OUT_V_ITEM_PRO', // 虚表表名
    special: 'DL_B_TRAN_OUT_V_ITEM_SKU', // 特殊情况
    secondTab: 'DL_B_TRAN_OUT_V_ITEM_SKU', // input为配置时单条码和矩阵的保存fixcolumn里面的表名key
    matchData: {
      data: [{
        label: t('发货店仓'),
        value: 'qty_stock_able',
        port: 1, // 表示第一个接口
      },
        {
          label: t('收货仓库'),
          value: 'qty_stock_able',
          port: 2, // 表示第二个接口
        },
      ],
    }, // 匹配的一些参数
    hasMatch: true, // 是否有匹配矩阵
    hasStock: true, // 获取库存接口
    hasReceiving: true, // 显示收货在库和可用
    isStock: false, // 配置默认显示在库的还是可用的
    isDeleteBtn: true, // 是否有删除明细按钮
    inputList: [{
      name: t('数量'),
      colname: 'QTY_BILL',
      defnum: 1
    }], // 配的数量字段名集合
    matrixInput: false, // 是否显示数量框
  }, // 调拨出库单(这个页面情况复杂)
  DL_B_TRAN_IN_CHANGE: {
    getBody: '/api/cs/oc/oms/v1/getMatrixData', // 获取商品编码各个SKU数量（用于修改）
    amendBody: '/p/cs/objectSave', // 保存修改的商品编码各个SKU数量
    singleCode: '/p/cs/barcodeSave', // 单条码数量保存
    tableName: 'DL_B_TRAN_IN_V_ITEM_SKU_CHANGE', // 子表表名
    virtualName: 'DL_B_TRAN_IN_V_ITEM_SKU_CHANGE', // 虚表表名
    hasMatch: false, // 是否有匹配矩阵
    matchData: {},
    isDeleteBtn: false, // 是否有删除明细按钮
    hasStock: true, // 获取库存接口
    isStock: true, // 配置默认显示在库的还是可用的
    inputList: [{
      name: t('数量'),
      colname: 'QTY_BILL',
      defnum: 1
    }], // 配的数量字段名集合
    matrixInput: false, // 是否显示数量框
  }, // 调拨入库单改单
  DL_B_INV_ADJ: {
    getBody: '/api/cs/oc/oms/v1/getMatrixData', // 获取商品编码各个SKU数量（用于修改）
    amendBody: '/p/cs/objectSave', // 保存修改的商品编码各个SKU数量
    singleCode: '/p/cs/barcodeSave', // 单条码数量保存
    tableName: 'DL_B_INV_ADJ_ITEM', // 子表表名
    queryObjSave: 'DL_B_INV_ADJ_ITEM', // 左边列表保存字段名
    virtualName: 'DL_B_INV_ADJ_ITEM_PRO', // 虚表表名
    matchData: {
      data: [{
        label: '在库库存',
        value: 'qty_stock', // 字段名
        port: 1, // 表示第一个接口
      },
        {
          label: '可用库存',
          value: 'qty_stock_able', // 字段名
          port: 1, // 表示第一个接口
        },
      ],
    }, // 匹配的一些参数
    hasMatch: true, // 是否有匹配矩阵
    isDeleteBtn: true, // 是否有删除明细按钮
    hasStock: true, // 获取库存接口
    isStock: true, // 配置默认显示在库的还是可用的
    inputList: [{
      name: t('数量'),
      colname: 'QTY_BILL',
      defnum: 1
    }], // 配的数量字段名集合
    matrixInput: false, // 是否显示数量框
  }, // 库存调整单
  DL_B_PFT_LOS: {
    getBody: '/api/cs/oc/oms/v1/getMatrixData', // 获取商品编码各个SKU数量（用于修改）
    amendBody: '/p/cs/objectSave', // 保存修改的商品编码各个SKU数量
    singleCode: '/p/cs/barcodeSave', // 单条码数量保存
    tableName: 'DL_B_PFT_LOS_ITEM', // 子表表名
    queryObjSave: 'DL_B_PFT_LOS_ITEM', // 左边列表保存字段名
    virtualName: 'DL_B_PFT_LOSS_DETAIL', // 虚表表名
    hasMatch: false, // 是否有匹配矩阵
    isDeleteBtn: false, // 是否有删除明细按钮
    matchData: {},
    hasStock: false, // 获取库存接口
    inputList: [{
      name: t('数量'),
      colname: 'QTY_BILL',
      defnum: 1
    }], // 配的数量字段名集合
    matrixInput: false, // 是否显示数量框
  },
  /* 盈亏单 */
  DL_B_INV_ADJ_WORK_PICK: {
    getBody: '/api/cs/oc/oms/v1/getMatrixData', // 获取商品编码各个SKU数量（用于修改）
    amendBody: '/p/cs/objectSave', // 保存修改的商品编码各个SKU数量
    singleCode: '/p/cs/barcodeSave', // 单条码数量保存
    tableName: 'DL_B_INV_ADJ_ITEM', // 子表表名
    queryObjSave: 'DL_B_INV_ADJ_ITEM', // 左边列表保存字段名
    virtualName: 'DL_B_INV_ADJ_ITEM_PRO', // 虚表表名
    hasMatch: false, // 是否有匹配矩阵
    isDeleteBtn: true, // 是否有删除明细按钮
    matchData: {},
    hasStock: true, // 获取库存接口
    isStock: true, // 配置默认显示在库的还是可用的
    inputList: [{
      name: t('数量'),
      colname: 'QTY_BILL',
      defnum: 1
    }], // 配的数量字段名集合
    matrixInput: false, // 是否显示数量框
  }, // 商品出库单
  DL_B_INV_ADJ_WORK_PICK_POS: {
    getBody: '/api/cs/oc/oms/v1/getMatrixData', // 获取商品编码各个SKU数量（用于修改）
    amendBody: '/p/cs/objectSave', // 保存修改的商品编码各个SKU数量
    singleCode: '/p/cs/barcodeSave', // 单条码数量保存
    tableName: 'DL_B_INV_ADJ_ITEM', // 子表表名
    queryObjSave: 'DL_B_INV_ADJ_ITEM', // 左边列表保存字段名
    virtualName: 'DL_B_INV_ADJ_ITEM_PRO', // 虚表表名
    hasMatch: false, // 是否有匹配矩阵
    isDeleteBtn: false, // 是否有删除明细按钮
    matchData: {},
    hasStock: true, // 获取库存接口
    isStock: true, // 配置默认显示在库的还是可用的
    inputList: [{
      name: t('数量'),
      colname: 'QTY_BILL',
      defnum: 1
    }], // 配的数量字段名集合
    matrixInput: false, // 是否显示数量框
  }, // 门店工衣领用单
  DL_B_TRAN_OUT_CHANGE: {
    getBody: '/api/cs/oc/oms/v1/getMatrixData', // 获取商品编码各个SKU数量（用于修改）
    amendBody: '/p/cs/objectSave', // 保存修改的商品编码各个SKU数量
    singleCode: '/p/cs/barcodeSave', // 单条码数量保存
    tableName: 'DL_B_TRAN_OUT_V_ITEM_SKU_CHANGE', // 子表表名
    queryObjSave: 'DL_B_TRAN_OUT_V_ITEM_SKU_CHANGE', // 左边列表保存字段名
    virtualName: 'DL_B_TRAN_OUT_V_ITEM_SKU_CHANGE', // 虚表表名
    hasMatch: false, // 是否有匹配矩阵
    matchData: {},
    isDeleteBtn: false, // 是否有删除明细按钮
    hasStock: true, // 获取库存接口
    isStock: true, // 配置默认显示在库的还是可用的
    inputList: [{
      name: t('数量'),
      colname: 'QTY_BILL',
      defnum: 1
    }], // 配的数量字段名集合
    matrixInput: false, // 是否显示数量框
  }, // 出库单改单
  DL_B_TRAN_BOX_CHANGE: {
    getBody: '/api/cs/oc/oms/v1/getMatrixData', // 获取商品编码各个SKU数量（用于修改）
    amendBody: '/p/cs/objectSave', // 保存修改的商品编码各个SKU数量
    singleCode: '/p/cs/barcodeSave', // 单条码数量保存
    tableName: 'DL_B_TRAN_BOX_CHANGE', // 子表表名
    queryObjSave: 'DL_B_TRAN_BOX_CHANGE', // 左边列表保存字段名
    virtualName: 'DL_B_TRAN_OUT_V_ITEM_SKU_CHANGE', // 虚表表名
    hasMatch: false, // 是否有匹配矩阵
    matchData: {},
    isDeleteBtn: false, // 是否有删除明细按钮
    hasStock: true, // 获取库存接口
    isStock: true, // 配置默认显示在库的还是可用的
    inputList: [{
      name: t('数量'),
      colname: 'QTY_BILL',
      defnum: 1
    }], // 配的数量字段名集合
    matrixInput: false, // 是否显示数量框
  }, // 拣货装箱改单
  DL_B_PUR_RET: {
    getBody: '/api/cs/oc/oms/v1/getMatrixData', // 获取商品编码各个SKU数量（用于修改）
    amendBody: '/p/cs/objectSave', // 保存修改的商品编码各个SKU数量
    singleCode: '/p/cs/barcodeSave', // 单条码数量保存
    tableName: 'DL_B_PUR_RET_ITEM', // 子表表名
    queryObjSave: 'DL_B_PUR_RET_ITEM', // 左边列表保存字段名
    virtualName: 'DL_B_PUR_RET_ITEM_MATRIX', // 虚表表名
    matchData: {
      data: [{
        label: '退货店仓可用',
        value: 'qty_stock_able',
        port: 1, // 表示第一个接口
      },
        {
          label: '退货店仓在库',
          value: 'qty_stock',
          port: 1, // 表示第一个接口
        },
      ],
    }, // 匹配的一些参数
    hasMatch: true, // 是否有匹配矩阵
    hasStock: true, // 获取库存接口
    isStock: false, // 配置默认显示在库的还是可用的
    isDeleteBtn: true, // 是否有删除明细按钮
    inputList: [{
      name: t('数量'),
      colname: 'QTY_BILL',
      defnum: 1
    }], // 配的数量字段名集合
    matrixInput: false, // 是否显示数量框
  }, // 采购退货
  DL_B_RETAIL: {
    getBody: '/api/cs/oc/oms/v1/getMatrixData', // 获取商品编码各个SKU数量（用于修改）
    amendBody: '/p/cs/objectSave', // 保存修改的商品编码各个SKU数量
    singleCode: '/p/cs/barcodeSave', // 单条码数量保存
    tableName: 'DL_B_RETAIL_ITEM', // 子表表名
    queryObjSave: 'DL_B_RETAIL_ITEM', // 左边列表保存字段名
    virtualName: 'DL_B_PUR_REQ_ITEM_V', // 虚表表名
    isDeleteBtn: true, // 是否有删除明细按钮
    hasMatch: false, // 是否有匹配矩阵
    deletePort: 'p/cs/retailitemdel', // 删除明细接口
    matchData: {},
    hasStock: true, // 获取库存接口
    isStock: true, // 配置默认显示在库的还是可用的
    inputList: [{
      name: t('数量'),
      colname: 'QTY_BILL',
      defnum: 1
    }], // 配的数量字段名集合
    matrixInput: false, // 是否显示数量框
  }, // 零售单
  DL_B_USE_ORDER: {
    getBody: '/api/cs/oc/oms/v1/getMatrixData', // 获取商品编码各个SKU数量（用于修改）
    amendBody: '/p/cs/objectSave', // 保存修改的商品编码各个SKU数量
    singleCode: '/p/cs/barcodeSave', // 单条码数量保存
    tableName: 'DL_B_USE_ORDER_ITEM', // 子表表名
    queryObjSave: 'DL_B_USE_ORDER_ITEM', // 左边列表保存字段名
    virtualName: 'DL_B_PUR_REQ_ITEM_V', // 虚表表名
    isDeleteBtn: true, // 是否有删除明细按钮
    hasMatch: false, // 是否有匹配矩阵
    deletePort: 'p/cs/retailitemdel', // 删除明细接口
    isStoreId: false,
    matchData: {},
    hasStock: true, // 获取库存接口
    isStock: true, // 配置默认显示在库的还是可用的
    inputList: [{
      name: t('数量'),
      colname: 'QTY_BILL',
      defnum: 1
    }], // 配的数量字段名集合
    matrixInput: false, // 是否显示数量框
  }, // 领用单
  DL_B_RETURN_ORDER: {
    getBody: '/api/cs/oc/oms/v1/getMatrixData', // 获取商品编码各个SKU数量（用于修改）
    amendBody: '/p/cs/objectSave', // 保存修改的商品编码各个SKU数量
    singleCode: '/p/cs/barcodeSave', // 单条码数量保存
    tableName: 'DL_B_RETURN_ORDER_ITEM', // 子表表名
    queryObjSave: 'DL_B_RETURN_ORDER_ITEM', // 左边列表保存字段名
    virtualName: 'DL_B_PUR_REQ_ITEM_V', // 虚表表名
    isDeleteBtn: true, // 是否有删除明细按钮
    hasMatch: false, // 是否有匹配矩阵
    deletePort: 'p/cs/retailitemdel', // 删除明细接口
    isStoreId: false,
    matchData: {},
    hasStock: true, // 获取库存接口
    isStock: true, // 配置默认显示在库的还是可用的
    inputList: [{
      name: t('数量'),
      colname: 'QTY_BILL',
      defnum: 1
    }], // 配的数量字段名集合
    matrixInput: false, // 是否显示数量框
  }, // 领用归还单
  DL_B_OA_APPLICATION_FORM: {
    getBody: '/api/cs/oc/oms/v1/getMatrixData', // 获取商品编码各个SKU数量（用于修改）
    amendBody: '/p/cs/objectSave', // 保存修改的商品编码各个SKU数量
    singleCode: '/p/cs/barcodeSave', // 单条码数量保存
    tableName: 'DL_B_OA_APPLICATION_FORM_ITEM', // 子表表名
    queryObjSave: 'DL_B_OA_APPLICATION_FORM_ITEM', // 左边列表保存字段名
    virtualName: '', // 虚表表名
    isDeleteBtn: true, // 是否有删除明细按钮
    hasMatch: false, // 是否有匹配矩阵
    deletePort: 'p/cs/retailitemdel', // 删除明细接口
    isStoreId: false,
    matchData: {},
    hasStock: true, // 获取库存接口
    isStock: true, // 配置默认显示在库的还是可用的
    inputList: [{
      name: t('数量'),
      colname: 'QTY_BILL',
      defnum: 1
    }], // 配的数量字段名集合
    matrixInput: false, // 是否显示数量框
  }, // OA申请零售单
  DL_B_PAND: {
    getBody: '/api/cs/oc/oms/v1/getMatrixData', // 获取商品编码各个SKU数量（用于修改）
    amendBody: '/p/cs/objectSave', // 保存修改的商品编码各个SKU数量
    singleCode: '/p/cs/barcodeSave', // 单条码数量保存
    tableName: 'DL_B_PAND_ITEM', // 子表表名
    queryObjSave: 'DL_B_PAND_ITEM', // 左边列表保存字段名
    virtualName: 'DL_B_PAND_ITEM_PRO', // 实表表名
    hasMatch: true, // 是否有匹配矩阵
    matchData: {
      data: [{
        label: '在库库存',
        value: 'qty_stock', // 字段名
        port: 1, // 表示第一个接口
      },
        {
          label: '可用库存',
          value: 'qty_stock_able', // 字段名
          port: 1, // 表示第一个接口
        },
      ],
    },
    hasStock: true, // 获取库存接口
    isStock: true, // 配置默认显示在库的还是可用的
    isDeleteBtn: true, // 是否有删除明细按钮
    inputList: [{
      name: t('数量'),
      colname: 'QTY_BILL',
      defnum: 1
    }], // 配的数量字段名集合
    matrixInput: false, // 是否显示数量框
  }, // 盘点单
  DL_B_TRAN_PLAN: {
    getBody: '/api/cs/oc/oms/v1/getMatrixData', // 获取商品编码各个SKU数量（用于修改）
    amendBody: '/p/cs/objectSave', // 保存修改的商品编码各个SKU数量
    singleCode: '/p/cs/barcodeSave', // 单条码数量保存
    tableName: 'DL_B_TRAN_PLAN_ITEM', // 子表表名
    queryObjSave: 'DL_B_TRAN_PLAN_ITEM', // 左边列表保存字段名
    virtualName: 'DL_B_TRAN_PLAN_V_ITEM', // 虚表表名
    isDeleteBtn: false, // 是否有删除明细按钮
    matchData: {},
    hasMatch: false, // 是否有匹配矩阵
    hasStock: true, // 不获取库存接口
    isStock: false, // 配置默认显示在库的还是可用的
    inputList: [{
      name: t('数量'),
      colname: 'QTY_EXEC_PLAN',
      defnum: 1
    }], // 配的数量字段名集合
    matrixInput: false, // 是否显示数量框
  }, // 调拨计划单新增
  DL_B_PUR_TMPIN: {
    getBody: '/api/cs/oc/oms/v1/getMatrixData', // 获取商品编码各个SKU数量（用于修改）
    amendBody: '/p/cs/objectSave', // 保存修改的商品编码各个SKU数量
    singleCode: '/p/cs/barcodeSave', // 单条码数量保存
    tableName: 'DL_B_PUR_TMPIN_ITEM', // 子表表名
    queryObjSave: 'DL_B_PUR_TMPIN_ITEM', // 左边列表保存字段名
    virtualName: 'DL_B_PUR_TMPIN_ITEM_MATRIX', // 虚表表名
    isDeleteBtn: true, // 是否有删除明细按钮
    matchData: {},
    hasMatch: false, // 是否有匹配矩阵
    hasStock: true, // 获取库存接口
    isStock: true, // 配置默认显示在库的还是可用的
    inputList: [{
      name: t('数量'),
      colname: 'QTY_BILL',
      defnum: 1
    }], // 配的数量字段名集合
    matrixInput: false, // 是否显示数量框
  }, // 货品暂收
  OC_B_RETURN_ORDER: {
    getBody: '/api/cs/oc/oms/v1/getMatrixData', // 获取商品编码各个SKU数量（用于修改）
    amendBody: '/p/cs/objectSave', // 保存修改的商品编码各个SKU数量
    singleCode: '/p/cs/barcodeSave', // 单条码数量保存
    tableName: 'OC_B_RETURN_ORDER_REFUND', // 子表表名
    queryObjSave: 'OC_B_RETURN_ORDER_REFUND', // 左边列表保存字段名
    virtualName: 'OC_B_RETURN_ORDER_REFUND', // 虚表表名
    isDeleteBtn: true, // 是否有删除明细按钮
    matchData: {},
    hasMatch: false, // 是否有匹配矩阵
    hasStock: true, // 获取库存接口
    isStock: true, // 配置默认显示在库的还是可用的
    inputList: [{
      name: t('数量'),
      colname: 'QTY_BILL',
      defnum: 1
    }], // 配的数量字段名集合
    matrixInput: false, // 是否显示数量框
  }, // 退换货订单
  OC_B_SALE: {
    getBody: '/api/cs/oc/oms/v1/getMatrixData', // 获取商品编码各个SKU数量（用于修改）
    amendBody: '/p/cs/objectSave', // 保存修改的商品编码各个SKU数量
    singleCode: '/p/cs/barcodeSave', // 单条码数量保存
    tableName: 'OC_B_SALE_ITEM', // 子表表名
    queryObjSave: 'OC_B_SALE_ITEM', // 左边列表保存字段名
    virtualName: 'OC_B_SALE_ITEM_V', // 虚表表名
    isDeleteBtn: true, // 是否有删除明细按钮
    isUpdateDiscountBtn: false, // 是否有修改折扣按钮
    matchData: {},
    hasMatch: false, // 是否有匹配矩阵
    noZeroShwoFlag: true,
    hasStock: false, // 获取库存接口
    isStock: false, // 配置默认显示在库的还是可用的
    inputList: [{
      name: t('数量'),
      colname: 'QTY',
      defnum: 1
    }], // 配的数量字段名集合
    matrixInput: false, // 是否显示数量框
    hasReceiving: true,
    hasQtyPrein: true,
    hasRetail: true
  }, // 销售单
  SG_B_STO_ADJUST: {
    getBody: '/p/cs/sg/getMatrixData', // 获取商品编码各个SKU数量（用于修改）
    amendBody: '/p/cs/objectSave', // 保存修改的商品编码各个SKU数量
    singleCode: '/p/cs/barcodeSave', // 单条码数量保存
    tableName: 'SG_B_STO_ADJUST_ITEM', // 子表表名 -
    queryObjSave: 'SG_B_STO_ADJUST_ITEM', // 左边列表保存字段名
    virtualName: 'SG_B_STO_ADJUST_ITEM_PRO', // 虚表表名
    isDeleteBtn: true, // 是否有删除明细按钮
    delUrl: '/p/cs/sg/prodel', // 删除接口指定地址
    isUpdateDiscountBtn: false, // 是否有修改折扣按钮
    matchData: {},
    hasMatch: false, // 是否有匹配矩阵
    noZeroShwoFlag: true,
    hasStock: false, // 获取库存接口
    isStock: false, // 配置默认显示在库的还是可用的
    inputList: [{
      name: t('数量'),
      colname: 'QTY',
      defnum: 1
    }], // 配的数量字段名集合
    matrixInput: false, // 是否显示数量框
    hasReceiving: false,
    hasQtyPrein: false,
    hasRetail: false
  }, // 库存调整单
  SG_B_SHARE_ALLOCATION_RETURN: {
    getBody: '/p/cs/sg/getMatrixData', // 获取商品编码各个SKU数量（用于修改）
    amendBody: '/p/cs/objectSave', // 保存修改的商品编码各个SKU数量
    singleCode: '/p/cs/barcodeSave', // 单条码数量保存
    tableName: 'SG_B_SHARE_ALLOCATION_RETURN_ITEM', // 子表表名 -
    queryObjSave: 'SG_B_SHARE_ALLOCATION_RETURN_ITEM', // 左边列表保存字段名
    virtualName: 'SG_B_SHARE_ALLOCATION_RETURN_ITEM_V', // 虚表表名
    isDeleteBtn: true, // 是否有删除明细按钮
    shippingWarehouse: 'SG_C_SA_STORE_ID', // 发货仓取值字段 (主表)
    receivingWarehouse: 'SG_C_SHARE_STORE_ID', // 收货仓取值字段 (主表)
    shippingStock: '/p/cs/sg/storage/queryShareStoreStorageByPro', // 查发货仓库存
    receivingStock: '/p/cs/sg/storage/queryShareStorageByPro', // 查收货仓库存
    paramsNoStore: true, // 接口报："店仓ID错误，找不到该店仓" 时,/p/cs/matrix 接口不传 CP_C_STORE_ID 这个入参
    delUrl: '/p/cs/sg/prodel', // 删除接口指定地址
    isUpdateDiscountBtn: false, // 是否有修改折扣按钮
    matchData: {},
    hasMatch: false, // 是否有匹配矩阵
    hideInStock: true, // 是否隐藏在库（发货在库、收货在库）
    noZeroShwoFlag: true,
    hasStock: true, // 获取库存接口
    isStock: false, // 配置默认显示在库的还是可用的
    inputList: [{
      name: t('数量'),
      colname: 'QTY',
      defnum: 1
    }], // 配的数量字段名集合
    matrixInput: false, // 是否显示数量框
    hasReceiving: true, // 是否显示收货在库和可用
    hasQtyPrein: false, // 是否显示收货在途数量
    hasRetail: false // 是否显示零售数量
  }, // 分货退货单
  OC_B_PURCHASE: {
    getBody: '/api/cs/oc/oms/v1/getMatrixData', // 获取商品编码各个SKU数量（用于修改）
    amendBody: '/p/cs/objectSave', // 保存修改的商品编码各个SKU数量
    singleCode: '/p/cs/barcodeSave', // 单条码数量保存
    tableName: 'OC_B_PURCHASE_ITEM', // 子表表名
    queryObjSave: 'OC_B_PURCHASE_ITEM', // 左边列表保存字段名
    virtualName: 'OC_B_PURCHASE_ITEM_V', // 虚表表名
    isDeleteBtn: true, // 是否有删除明细按钮
    matchData: {},
    hasMatch: false, // 是否有匹配矩阵
    hasStock: false, // 获取库存接口
    isStock: true, // 配置默认显示在库的还是可用的
    inputList: [{
      name: t('数量'),
      colname: 'QTY',
      defnum: 1
    }], // 配的数量字段名集合
    matrixInput: false, // 是否显示数量框
    hasReceiving: false
  }, // 采购单
  SC_B_TRANSFER: {
    getBody: '/api/cs/oc/oms/v1/getMatrixData', // 获取商品编码各个SKU数量（用于修改）
    amendBody: '/p/cs/objectSave', // 保存修改的商品编码各个SKU数量
    singleCode: '/p/cs/barcodeSave', // 单条码数量保存
    tableName: 'SC_B_TRANSFER_ITEM', // 子表表名
    queryObjSave: 'SC_B_TRANSFER_ITEM', // 左边列表保存字段名
    virtualName: 'SC_B_TRANSFER_ITEM_V', // 虚表表名
    isDeleteBtn: true, // 是否有删除明细按钮
    matchData: {},
    hasMatch: false, // 是否有匹配矩阵
    hasStock: false, // 获取库存接口
    noZeroShwoFlag: true, // 不展示0
    isStock: false, // 配置默认显示在库的还是可用的
    inputList: [{
      name: t('数量'),
      colname: 'QTY',
      defnum: 1
    }], // 配的数量字段名集合
    matrixInput: false, // 是否显示数量框
    hasReceiving: true,
    hasQtyPrein: true,
    hasRetail: true
  }, // 调拨单
  V_SC_B_TRANSFER_BETWEEN: { // 仓间调拨
    getBody: '/api/cs/oc/oms/v1/getMatrixData', // 获取商品编码各个SKU数量（用于修改）
    amendBody: '/p/cs/objectSave', // 保存修改的商品编码各个SKU数量
    singleCode: '/p/cs/barcodeSave', // 单条码数量保存
    tableName: 'V_SC_B_TRANSFER_BETWEEN_ITEM', // 子表表名
    queryObjSave: 'SC_B_TRANSFER_ITEM', // 左边列表保存字段名
    virtualName: 'V_SC_B_TRANSFER_ITEM_BETWEEN_V', // 虚表表名
    isDeleteBtn: true, // 是否有删除明细按钮
    matchData: {},
    hasMatch: false, // 是否有匹配矩阵
    hasStock: false, // 获取库存接口
    noZeroShwoFlag: true, // 不展示0
    isStock: false, // 配置默认显示在库的还是可用的
    inputList: [{
      name: t('数量'),
      colname: 'QTY',
      defnum: 1
    }], // 配的数量字段名集合
    matrixInput: false, // 是否显示数量框
    hasReceiving: true,
    hasQtyPrein: true,
    hasRetail: true
  },
  V_SC_B_TRANSFER_WITHIN: { // 仓内调拨
    getBody: '/api/cs/oc/oms/v1/getMatrixData', // 获取商品编码各个SKU数量（用于修改）
    amendBody: '/p/cs/objectSave', // 保存修改的商品编码各个SKU数量
    singleCode: '/p/cs/barcodeSave', // 单条码数量保存
    tableName: 'V_SC_B_TRANSFER_WITHIN_ITEM', // 子表表名
    queryObjSave: 'SC_B_TRANSFER_ITEM', // 左边列表保存字段名
    virtualName: 'V_SC_B_TRANSFER_ITEM_WITHIN_V', // 虚表表名
    isDeleteBtn: true, // 是否有删除明细按钮
    matchData: {},
    hasMatch: false, // 是否有匹配矩阵
    hasStock: false, // 获取库存接口
    noZeroShwoFlag: true, // 不展示0
    isStock: false, // 配置默认显示在库的还是可用的
    inputList: [{
      name: t('数量'),
      colname: 'QTY',
      defnum: 1
    }], // 配的数量字段名集合
    matrixInput: false, // 是否显示数量框
    hasReceiving: true,
    hasQtyPrein: true,
    hasRetail: true
  },
  OC_B_ORDER: {
    getBody: '/api/cs/oc/oms/v1/getMatrixData', // 获取商品编码各个SKU数量（用于修改）
    amendBody: '/p/cs/objectSave', // 保存修改的商品编码各个SKU数量
    singleCode: '/p/cs/barcodeSave', // 单条码数量保存
    tableName: 'OC_B_ORDER_ITEM', // 子表表名
    queryObjSave: 'OC_B_ORDER_ITEM', // 左边列表保存字段名
    virtualName: 'OC_B_ORDER_ITEM_V', // 虚表表名
    isDeleteBtn: true, // 是否有删除明细按钮
    matchData: {},
    hasMatch: false, // 是否有匹配矩阵
    hasStock: false, // 获取库存接口
    isStock: true, // 配置默认显示在库的还是可用的
    inputList: [{
      name: t('数量'),
      colname: 'QTY',
      defnum: 1
    }], // 配的数量字段名集合
    matrixInput: false, // 是否显示数量框
    hasReceiving: false
  },
  SC_B_OUT: {
    getBody: '/api/cs/oc/oms/v1/getMatrixData', // 获取商品编码各个SKU数量（用于修改）
    amendBody: '/p/cs/objectSave', // 保存修改的商品编码各个SKU数量
    singleCode: '/p/cs/barcodeSave', // 单条码数量保存
    tableName: 'SC_B_OUT_ITEM', // 子表表名
    queryObjSave: 'SC_B_OUT_ITEM', // 左边列表保存字段名
    virtualName: 'SC_B_OUT_ITEM_V', // 虚表表名
    isDeleteBtn: true, // 是否有删除明细按钮
    matchData: {},
    hasMatch: false, // 是否有匹配矩阵
    hasStock: true, // 获取库存接口
    isStock: true, // 配置默认显示在库的还是可用的
    inputList: [{
      name: t('数量'),
      colname: 'QTY',
      defnum: 1
    }], // 配的数量字段名集合
    matrixInput: false, // 是否显示数量框
    hasReceiving: false
  }, // 出库单
  OC_B_SEND_OUT: {
    getBody: '/api/cs/oc/oms/v1/getMatrixData', // 获取商品编码各个SKU数量（用于修改）
    amendBody: '/p/cs/objectSave', // 保存修改的商品编码各个SKU数量
    singleCode: '/p/cs/barcodeSave', // 单条码数量保存
    tableName: 'OC_B_SEND_OUT_ITEM', // 子表表名
    queryObjSave: 'OC_B_SEND_OUT_ITEM', // 左边列表保存字段名
    virtualName: 'OC_B_SEND_OUT_ITEM_V', // 虚表表名
    isDeleteBtn: true, // 是否有删除明细按钮
    matchData: {},
    hasMatch: false, // 是否有匹配矩阵
    hasStock: true, // 获取库存接口
    isStock: true, // 配置默认显示在库的还是可用的
    inputList: [{
      name: t('数量'),
      colname: 'QTY',
      defnum: 1
    }], // 配的数量字段名集合
    matrixInput: false, // 是否显示数量框
    hasReceiving: false
  }, // 发货订单

  OC_B_REFUND_SALE: {
    getBody: '/api/cs/oc/oms/v1/getMatrixData', // 获取商品编码各个SKU数量（用于修改）
    amendBody: '/p/cs/objectSave', // 保存修改的商品编码各个SKU数量
    singleCode: '/p/cs/barcodeSave', // 单条码数量保存
    tableName: 'OC_B_REFUND_SALE_ITEM', // 子表表名
    queryObjSave: 'OC_B_REFUND_SALE_ITEM', // 左边列表保存字段名
    virtualName: 'OC_B_REFUND_SALE_ITEM_V', // 虚表表名
    isDeleteBtn: true, // 是否有删除明细按钮
    isUpdateDiscountBtn: false, // 是否有修改折扣明细按钮
    matchData: {},
    hasMatch: false, // 是否有匹配矩阵
    hasStock: false, // 获取库存接口
    isStock: true, // 配置默认显示在库的还是可用的
    inputList: [{
      name: t('数量'),
      colname: 'QTY',
      defnum: 1
    }], // 配的数量字段名集合
    matrixInput: false, // 是否显示数量框
    hasReceiving: false
  }, // 销售退货单
  OC_B_REFUND_PURCHASE: {
    getBody: '/api/cs/oc/oms/v1/getMatrixData', // 获取商品编码各个SKU数量（用于修改）
    amendBody: '/p/cs/objectSave', // 保存修改的商品编码各个SKU数量
    singleCode: '/p/cs/barcodeSave', // 单条码数量保存
    tableName: 'OC_B_REFUND_PURCHASE_ITEM', // 子表表名
    queryObjSave: 'OC_B_REFUND_PURCHASE_ITEM', // 左边列表保存字段名
    virtualName: 'OC_B_REFUND_PURCHASE_ITEM_V', // 虚表表名
    isDeleteBtn: true, // 是否有删除明细按钮
    matchData: {},
    hasMatch: false, // 是否有匹配矩阵
    hasStock: false, // 获取库存接口
    isStock: true, // 配置默认显示在库的还是可用的
    inputList: [{
      name: t('数量'),
      colname: 'QTY',
      defnum: 1
    }], // 配的数量字段名集合
    matrixInput: false, // 是否显示数量框
    hasReceiving: false
  }, // 采购退货单

  SC_B_INVENTORY: {
    getBody: '/api/cs/oc/oms/v1/getMatrixData', // 获取商品编码各个SKU数量（用于修改）
    amendBody: '/p/cs/objectSave', // 保存修改的商品编码各个SKU数量
    singleCode: '/p/cs/barcodeSave', // 单条码数量保存
    tableName: 'SC_B_INVENTORY_ITEM', // 子表表名
    queryObjSave: 'SC_B_INVENTORY_ITEM', // 左边列表保存字段名
    virtualName: 'SC_B_INVENTORY_ITEM_V', // 虚表表名
    isDeleteBtn: true, // 是否有删除明细按钮
    matchData: {},
    hasMatch: false, // 是否有匹配矩阵
    hasStock: true, // 获取库存接口
    isStock: true, // 配置默认显示在库的还是可用的
    inputList: [{
      name: t('数量'),
      colname: 'QTY',
      defnum: 1
    }], // 配的数量字段名集合
    matrixInput: false, // 是否显示数量框
    hasReceiving: false
  }, // 盘点单
  OC_B_PURCHASE_ORDER: {
    getBody: '/api/cs/oc/oms/v1/getMatrixData', // 获取商品编码各个SKU数量（用于修改）
    amendBody: '/p/cs/objectSave', // 保存修改的商品编码各个SKU数量
    singleCode: '/p/cs/barcodeSave', // 单条码数量保存
    tableName: 'OC_B_PURCHASE_ORDER_ITEM', // 子表表名
    queryObjSave: 'OC_B_PURCHASE_ORDER_ITEM', // 左边列表保存字段名
    virtualName: 'OC_B_PURCHASE_ORDER_ITEM_V', // 虚表表名
    isDeleteBtn: true, // 是否有删除明细按钮
    matchData: {},
    hasMatch: false, // 是否有匹配矩阵
    hasStock: true, // 获取库存接口
    isStock: true, // 配置默认显示在库的还是可用的
    inputList: [{
      name: t('数量'),
      colname: 'QTY',
      defnum: 1
    }], // 配的数量字段名集合
    matrixInput: false, // 是否显示数量框
    hasReceiving: false
  }, // 采购订单商品明细
  POS_SC_B_TRANSFER: {
    getBody: '/p/cs/posGetMatrixData', // 获取商品编码各个SKU数量（用于修改）
    amendBody: '/p/cs/objectSave', // 保存修改的商品编码各个SKU数量
    singleCode: '/p/cs/barcodeSave', // 单条码数量保存
    tableName: 'POS_SC_B_TRANSFER_ITEM', // 子表表名
    queryObjSave: 'POS_SC_B_TRANSFER_ITEM', // 左边列表保存字段名
    virtualName: 'POS_SC_B_TRANSFER_ITEM_V', // 虚表表名
    isDeleteBtn: true, // 是否有删除明细按钮
    matchData: {},
    hasMatch: false, // 是否有匹配矩阵
    hasStock: true, // 获取库存接口
    isStock: true, // 配置默认显示在库的还是可用的
    inputList: [{
      name: t('数量'),
      colname: 'QTY',
      defnum: 1
    }], // 配的数量字段名集合
    matrixInput: false, // 是否显示数量框
    hasReceiving: false
  }, // POS出库单
  OC_B_MULTI_STORE_DISTRIBUTION: {
    getBody: '/p/cs/oc/v1/sale/matrix', // 获取商品编码各个SKU数量（用于修改）
    amendBody: '/p/cs/objectSave', // 保存修改的商品编码各个SKU数量
    tableName: 'OC_B_MULTI_STORE_DISTRIBUTION_ITEM', // 子表表名
    queryObjSave: 'OC_B_MULTI_STORE_DISTRIBUTION_ITEM',
  }, // 多店配货获取矩阵
  OC_B_DIRECT: {
    getBody: '/api/cs/oc/oms/v1/getMatrixData', // 获取商品编码各个SKU数量（用于修改）
    amendBody: '/p/cs/objectSave', // 保存修改的商品编码各个SKU数量
    singleCode: '/p/cs/barcodeSave', // 单条码数量保存
    tableName: 'OC_B_DIRECT_ITEM', // 子表表名
    queryObjSave: 'OC_B_DIRECT_ITEM', // 左边列表保存字段名
    virtualName: 'OC_B_DIRECT_ITEM', // 虚表表名
    isDeleteBtn: true, // 是否有删除明细按钮
    matchData: {},
    hasMatch: false, // 是否有匹配矩阵
    hasStock: true, // 获取库存接口
    isStock: true, // 配置默认显示在库的还是可用的
    inputList: [{
      name: t('数量'),
      colname: 'QTY',
      defnum: 1
    }], // 配的数量字段名集合
    matrixInput: false, // 是否显示数量框
    hasReceiving: false
  }, // 直发单
  SC_B_TRANSFER_ENQUIRY: { // 要货调拨单
    getBody: '/api/cs/oc/oms/v1/getMatrixData', // 获取商品编码各个SKU数量（用于修改）
    amendBody: '/p/cs/objectSave', // 保存修改的商品编码各个SKU数量
    singleCode: '/p/cs/barcodeSave', // 单条码数量保存
    tableName: 'SC_B_TRANSFER_ENQUIRY_ITEM', // 子表表名
    queryObjSave: 'SC_B_TRANSFER_ENQUIRY_ITEM', // 左边列表保存字段名
    virtualName: 'SC_B_TRANSFER_ENQUIRY_ITEM', // 虚表表名
    isDeleteBtn: true, // 是否有删除明细按钮
    matchData: {},
    hasMatch: false, // 是否有匹配矩阵
    hasStock: true, // 获取库存接口
    isStock: true, // 配置默认显示在库的还是可用的
    inputList: [{
      name: t('数量'),
      colname: 'QTY',
      defnum: 1
    }], // 配的数量字段名集合
    matrixInput: false, // 是否显示数量框
    hasReceiving: false
  }, // 要货调拨单
  OC_B_STORE_ENQUIRY: { //  门店要货单
    getBody: '/api/cs/oc/oms/v1/getMatrixData', // 获取商品编码各个SKU数量（用于修改）
    amendBody: '/p/cs/objectSave', // 保存修改的商品编码各个SKU数量
    singleCode: '/p/cs/barcodeSave', // 单条码数量保存
    tableName: 'OC_B_STORE_ENQUIRY_ITEM', // 子表表名
    queryObjSave: 'OC_B_STORE_ENQUIRY_ITEM', // 左边列表保存字段名
    virtualName: 'OC_B_STORE_ENQUIRY_ITEM_V', // 虚表表名
    isDeleteBtn: true, // 是否有删除明细按钮
    matchData: {},
    hasMatch: false, // 是否有匹配矩阵
    hasStock: true, // 获取库存接口
    isStock: true, // 配置默认显示在库的还是可用的
    inputList: [{
      name: t('数量'),
      colname: 'QTY',
      defnum: 1
    }], // 配的数量字段名集合
    matrixInput: false, // 是否显示数量框
    hasReceiving: true
  }, //  门店要货单
  OC_B_CUSTOMER_CARGO: {
    getBody: '/api/cs/oc/oms/v1/getMatrixData', // 获取商品编码各个SKU数量（用于修改）
    amendBody: '/p/cs/objectSave', // 保存修改的商品编码各个SKU数量
    singleCode: '/p/cs/barcodeSave', // 单条码数量保存
    tableName: 'OC_B_CUSTOMER_CARGO_ITEM', // 子表表名
    queryObjSave: 'OC_B_CUSTOMER_CARGO_ITEM', // 左边列表保存字段名
    virtualName: 'OC_B_CUSTOMER_CARGO_ITEM_V', // 虚表表名
    isDeleteBtn: true, // 是否有删除明细按钮
    matchData: {},
    hasMatch: false, // 是否有匹配矩阵
    hasStock: true, // 获取库存接口
    isStock: true, // 配置默认显示在库的还是可用的
    inputList: [{
      name: t('数量'),
      colname: 'QTY',
      defnum: 1
    }], // 配的数量字段名集合
    matrixInput: false, // 是否显示数量框
    hasReceiving: false
  }, //  经销商调货单
};

// 库存中心
const inventoryCenterPort = {
  SG_B_PHY_ADJUST: {
    getBody: '/api/cs/sg/getMatrixData', // 获取商品编码各个SKU数量（用于修改）
    amendBody: '/p/cs/objectSave', // 保存修改的商品编码各个SKU数量
    singleCode: '/p/cs/barcodeSave', // 单条码数量保存
    tableName: 'SG_B_PHY_ADJUST_ITEM', // 子表表名
    queryObjSave: 'SG_B_PHY_ADJUST_ITEM', // 左边列表保存字段名
    virtualName: 'SG_B_PHY_ADJUST_ITEM_V', // 虚表表名
    isDeleteBtn: true, // 是否有删除明细按钮
    matchData: {},
    hasMatch: false, // 是否有匹配矩阵
    hasStock: false, // 获取库存接口
    isStock: true, // 配置默认显示在库的还是可用的
    inputList: [{
      name: t('数量'),
      colname: 'QTY',
      defnum: 1
    }], // 配的数量字段名集合
    matrixInput: false, // 是否显示数量框
    hasReceiving: false
  }, // 库存调整单
  SG_B_PHY_IN_NOTICES_POS: {
    getBody: '/p/cs/posGetMatrixData', // 获取商品编码各个SKU数量（用于修改）
    amendBody: '/p/cs/objectSave', // 保存修改的商品编码各个SKU数量
    singleCode: '/p/cs/barcodeSave', // 单条码数量保存
    tableName: 'SG_B_PHY_IN_NOTICES_POS_ITEM', // 子表表名
    queryObjSave: 'SG_B_PHY_IN_NOTICES_POS_ITEM', // 左边列表保存字段名
    virtualName: 'SG_B_PHY_IN_NOTICES_POS_ITEM_V', // 虚表表名
    isDeleteBtn: false, // 是否有删除明细按钮
    matchData: {},
    hasMatch: false, // 是否有匹配矩阵
    hasStock: true, // 获取库存接口
    isStock: true, // 配置默认显示在库的还是可用的
    inputList: [{
      name: t('数量'),
      colname: 'QTY',
      defnum: 1
    }], // 配的数量字段名集合
    matrixInput: false, // 是否显示数量框
    hasReceiving: false
  }, // POS入库单
  SG_B_PHY_OUT_NOTICES_POS: {
    getBody: '/p/cs/posGetMatrixData', // 获取商品编码各个SKU数量（用于修改）
    amendBody: '/p/cs/objectSave', // 保存修改的商品编码各个SKU数量
    singleCode: '/p/cs/barcodeSave', // 单条码数量保存
    tableName: 'SG_B_PHY_OUT_NOTICES_POS_ITEM', // 子表表名
    queryObjSave: 'SG_B_PHY_OUT_NOTICES_POS_ITEM', // 左边列表保存字段名
    virtualName: 'SG_B_PHY_OUT_NOTICES_POS_ITEM', // 虚表表名
    isDeleteBtn: true, // 是否有删除明细按钮
    matchData: {},
    hasMatch: false, // 是否有匹配矩阵
    hasStock: true, // 获取库存接口
    isStock: true, // 配置默认显示在库的还是可用的
    inputList: [{
      name: t('数量'),
      colname: 'QTY',
      defnum: 1
    }], // 配的数量字段名集合
    matrixInput: false, // 是否显示数量框
    hasReceiving: false
  }, // 全渠道发货单
  SG_B_PHY_OUT_NOTICES_ALL_PICK: {
    getBody: '/p/cs/posGetMatrixData', // 获取商品编码各个SKU数量（用于修改）
    // getBody: '/api/cs/sg/getMatrixData', // 获取商品编码各个SKU数量（用于修改）
    amendBody: '/p/cs/objectSave', // 保存修改的商品编码各个SKU数量
    singleCode: '/p/cs/barcodeSave', // 单条码数量保存
    tableName: 'SG_B_PHY_OUT_NOTICES_ALL_PICK_ITEM', // 子表表名
    queryObjSave: 'SG_B_PHY_OUT_NOTICES_ALL_PICK_ITEM', // 左边列表保存字段名
    virtualName: 'SG_B_PHY_OUT_NOTICES_ALL_PICK_ITEM', // 虚表表名
    isDeleteBtn: true, // 是否有删除明细按钮
    matchData: {},
    hasMatch: false, // 是否有匹配矩阵
    hasStock: true, // 获取库存接口
    isStock: true, // 配置默认显示在库的还是可用的
    inputList: [{
      name: t('数量'),
      colname: 'QTY',
      defnum: 1
    }], // 配的数量字段名集合
    matrixInput: false, // 是否显示数量框
    hasReceiving: false
  }, // 全渠道自提单
  SG_B_GROUP_MANIFEST: {
    getBody: '/api/cs/sg/getMatrixData', // 获取商品编码各个SKU数量（用于修改）
    tableName: 'SG_B_GROUP_MANIFEST_ITEM',
    singleCode: '/p/cs/barcodeSave', // 单条码数量保存
    virtualName: 'SG_B_GROUP_MANIFEST_ITEM_V', // 虚表表名
    hasStock: false, // 获取库存接口
    isStoreId: true, // 是否传参 店仓/逻辑仓ID
    isMatchSize: 0,
    amendBody: '/p/cs/objectSave' // 保存修改的商品编码各个SKU数量
  }, // 组货单
  SG_B_STO_ADJUST: {
    getBody: '/api/cs/sg/getMatrixData', // 获取商品编码各个SKU数量（用于修改）
    amendBody: '/p/cs/objectSave', // 保存修改的商品编码各个SKU数量
    singleCode: '/p/cs/barcodeSave', // 单条码数量保存
    tableName: 'SG_B_STO_ADJUST_ITEM', // 子表表名 -
    queryObjSave: 'SG_B_STO_ADJUST_ITEM', // 左边列表保存字段名
    virtualName: 'SG_B_STO_ADJUST_ITEM_PRO', // 虚表表名
    isDeleteBtn: true, // 是否有删除明细按钮
    delUrl: '/api/cs/sg/prodel', // 删除接口指定地址
    isUpdateDiscountBtn: false, // 是否有修改折扣按钮
    matchData: {},
    hasMatch: false, // 是否有匹配矩阵
    noZeroShwoFlag: true,
    hasStock: false, // 获取库存接口
    isStock: false, // 配置默认显示在库的还是可用的
    inputList: [{
      name: t('数量'),
      colname: 'QTY',
      defnum: 1
    }], // 配的数量字段名集合
    matrixInput: false, // 是否显示数量框
    hasReceiving: false,
    hasQtyPrein: false,
    hasRetail: false
  }, // 库存调整单
  SG_B_STO_TRANSFER: {
    getBody: '/api/cs/sg/getMatrixData', // 获取商品编码各个SKU数量（用于修改）
    amendBody: '/p/cs/objectSave', // 保存修改的商品编码各个SKU数量
    singleCode: '/p/cs/barcodeSave', // 单条码数量保存
    tableName: 'SG_B_STO_TRANSFER_ITEM', // 子表表名 -
    queryObjSave: 'SG_B_STO_TRANSFER_ITEM_V', // 左边列表保存字段名
    virtualName: 'SG_B_STO_TRANSFER_ITEM_V', // 虚表表名
    receivingWarehouse: 'RECEIVER_STORE_ID', // 收货仓取值字段 (主表)
    isDeleteBtn: true, // 是否有删除明细按钮
    delUrl: '/api/cs/sg/prodel', // 删除接口指定地址
    isUpdateDiscountBtn: false, // 是否有修改折扣按钮
    matchData: {},
    hasMatch: false, // 是否有匹配矩阵
    noZeroShwoFlag: true,
    hasStock: true, // 获取库存接口
    isStock: false, // 配置默认显示在库的还是可用的
    inputList: [{
      name: t('数量'),
      colname: 'QTY',
      defnum: 1
    }], // 配的数量字段名集合
    matrixInput: false, // 是否显示数量框
    hasReceiving: true, // 是否显示收货在库和可用
    hasQtyPrein: false, // 是否显示收货在途数量
    hasRetail: false // 是否显示零售数量
  }, // 逻辑调拨单
  SG_B_STO_UNFREEZE: {
    getBody: '/api/cs/sg/getMatrixData', // 获取商品编码各个SKU数量（用于修改）
    amendBody: '/p/cs/objectSave', // 保存修改的商品编码各个SKU数量
    singleCode: '/p/cs/barcodeSave', // 单条码数量保存
    tableName: 'SG_B_STO_UNFREEZE_ITEM', // 子表表名 -
    queryObjSave: 'SG_B_STO_UNFREEZE_ITEM_V', // 左边列表保存字段名
    virtualName: 'SG_B_STO_UNFREEZE_ITEM_V', // 虚表表名
    isDeleteBtn: true, // 是否有删除明细按钮
    delUrl: '/api/cs/sg/prodel', // 删除接口指定地址
    isUpdateDiscountBtn: false, // 是否有修改折扣按钮
    matchData: {},
    hasMatch: false, // 是否有匹配矩阵
    noZeroShwoFlag: true,
    hasStock: false, // 获取库存接口
    isStock: false, // 配置默认显示在库的还是可用的
    inputList: [{
      name: t('数量'),
      colname: 'QTY',
      defnum: 1
    }], // 配的数量字段名集合
    matrixInput: false, // 是否显示数量框
    hasReceiving: false,
    hasQtyPrein: false,
    hasRetail: false
  }, // 逻辑解冻单
  SG_B_STO_STORE_ADVANCE_SALE: {
    getBody: '/api/cs/sg/getMatrixData', // 获取商品编码各个SKU数量（用于修改）
    amendBody: '/p/cs/objectSave', // 保存修改的商品编码各个SKU数量
    singleCode: '/p/cs/barcodeSave', // 单条码数量保存
    tableName: 'SG_B_STO_STORE_ADVANCE_SALE_ITEM', // 子表表名 -
    queryObjSave: 'SG_B_STO_STORE_ADVANCE_SALE_ITEM_V', // 左边列表保存字段名
    virtualName: 'SG_B_STO_STORE_ADVANCE_SALE_ITEM_V', // 虚表表名
    isDeleteBtn: true, // 是否有删除明细按钮
    delUrl: '/api/cs/sg/prodel', // 删除接口指定地址
    isUpdateDiscountBtn: false, // 是否有修改折扣按钮
    matchData: {},
    hasMatch: false, // 是否有匹配矩阵
    noZeroShwoFlag: true,
    hasStock: false, // 获取库存接口
    isStock: false, // 配置默认显示在库的还是可用的
    inputList: [{
      name: t('数量'),
      colname: 'QTY',
      defnum: 1
    }], // 配的数量字段名集合
    matrixInput: false, // 是否显示数量框
    hasReceiving: false,
    hasQtyPrein: false,
    hasRetail: false
  }, // 门店预售活动
  SG_B_SHARE_ADJUST: {
    getBody: '/api/cs/sg/getMatrixData', // 获取商品编码各个SKU数量（用于修改）
    amendBody: '/p/cs/objectSave', // 保存修改的商品编码各个SKU数量
    singleCode: '/p/cs/barcodeSave', // 单条码数量保存
    tableName: 'sg_b_share_adjust_item', // 子表表名 -
    queryObjSave: 'SG_B_SHARE_ADJUST_ITEM_V', // 左边列表保存字段名
    virtualName: 'SG_B_SHARE_ADJUST_ITEM_V', // 虚表表名
    isDeleteBtn: true, // 是否有删除明细按钮
    delUrl: '/api/cs/sg/prodel', // 删除接口指定地址
    isUpdateDiscountBtn: false, // 是否有修改折扣按钮
    matchData: {},
    hasMatch: false, // 是否有匹配矩阵
    noZeroShwoFlag: true,
    hasStock: false, // 获取库存接口
    isStock: false, // 配置默认显示在库的还是可用的
    inputList: [{
      name: t('数量'),
      colname: 'QTY',
      defnum: 1
    }], // 配的数量字段名集合
    matrixInput: false, // 是否显示数量框
    hasReceiving: false,
    hasQtyPrein: false,
    hasRetail: false
  }, // 共享调整单
  SG_B_STO_FREEZE: {
    getBody: '/api/cs/sg/getMatrixData', // 获取商品编码各个SKU数量（用于修改）
    amendBody: '/p/cs/objectSave', // 保存修改的商品编码各个SKU数量
    singleCode: '/p/cs/barcodeSave', // 单条码数量保存
    tableName: 'sg_b_sto_freeze_item', // 子表表名 -
    queryObjSave: 'SG_B_STO_FREEZE_ITEM_V', // 左边列表保存字段名
    virtualName: 'SG_B_STO_FREEZE_ITEM_V', // 虚表表名
    isDeleteBtn: true, // 是否有删除明细按钮
    delUrl: '/api/cs/sg/prodel', // 删除接口指定地址
    isUpdateDiscountBtn: false, // 是否有修改折扣按钮
    matchData: {},
    hasMatch: false, // 是否有匹配矩阵
    noZeroShwoFlag: true,
    hasStock: false, // 获取库存接口
    isStock: false, // 配置默认显示在库的还是可用的
    inputList: [{
      name: t('数量'),
      colname: 'QTY',
      defnum: 1
    }], // 配的数量字段名集合
    matrixInput: false, // 是否显示数量框
    hasReceiving: false,
    hasQtyPrein: false,
    hasRetail: false
  }, // 逻辑冻结单
  SG_B_SHARE_ALLOCATION_RETURN: {
    getBody: '/api/cs/sg/getMatrixData', // 获取商品编码各个SKU数量（用于修改）
    amendBody: '/p/cs/objectSave', // 保存修改的商品编码各个SKU数量
    singleCode: '/p/cs/barcodeSave', // 单条码数量保存
    tableName: 'SG_B_SHARE_ALLOCATION_RETURN_ITEM', // 子表表名 -
    queryObjSave: 'SG_B_SHARE_ALLOCATION_RETURN_ITEM', // 左边列表保存字段名
    virtualName: 'SG_B_SHARE_ALLOCATION_RETURN_ITEM_V', // 虚表表名
    isDeleteBtn: true, // 是否有删除明细按钮
    shippingWarehouse: 'SG_C_SA_STORE_ID', // 发货仓取值字段 (主表)
    receivingWarehouse: 'SG_C_SHARE_STORE_ID', // 收货仓取值字段 (主表)
    shippingStock: '/api/cs/sg/storage/queryShareStoreStorageByPro', // 查发货仓库存
    receivingStock: '/api/cs/sg/storage/queryShareStorageByPro', // 查收货仓库存
    paramsNoStore: true, // 接口报："店仓ID错误，找不到该店仓" 时,/api/cs/md/matrix 接口不传 CP_C_STORE_ID 这个入参
    delUrl: '/api/cs/sg/prodel', // 删除接口指定地址
    isUpdateDiscountBtn: false, // 是否有修改折扣按钮
    matchData: {},
    hasMatch: false, // 是否有匹配矩阵
    hideInStock: true, // 是否隐藏在库（发货在库、收货在库）
    noZeroShwoFlag: true,
    hasStock: true, // 获取库存接口
    isStock: false, // 配置默认显示在库的还是可用的
    inputList: [{
      name: t('数量'),
      colname: 'QTY',
      defnum: 1
    }], // 配的数量字段名集合
    matrixInput: false, // 是否显示数量框
    hasReceiving: true, // 是否显示收货在库和可用
    hasQtyPrein: false, // 是否显示收货在途数量
    hasRetail: false // 是否显示零售数量
  }, // 分货退货单
  SG_B_SHARE_ALLOCATION: {
    getBody: '/api/cs/sg/getMatrixData', // 获取商品编码各个SKU数量（用于修改）
    amendBody: '/p/cs/objectSave', // 保存修改的商品编码各个SKU数量
    singleCode: '/p/cs/barcodeSave', // 单条码数量保存
    tableName: 'SG_B_SHARE_ALLOCATION_ITEM', // 子表表名 -
    queryObjSave: 'SG_B_SHARE_ALLOCATION_ITEM', // 左边列表保存字段名
    virtualName: 'SG_B_SHARE_ALLOCATION_ITEM_V', // 虚表表名
    isDeleteBtn: true, // 是否有删除明细按钮
    shippingWarehouse: 'SG_C_SHARE_STORE_ID', // 发货仓取值字段 (主表)
    // receivingWarehouse: '', // 收货仓取值字段 (主表)
    receivingWarehouseInDetailTable: 'SG_C_SA_STORE_ID', // 收货仓取值字段 (明细表) - 主表没有收货仓时，去左边表格取，如：分货单界面只有一个聚合仓（发货仓）
    leftDataStoreId: 'SG_C_SA_STORE_ID', // 发货仓取值字段 - ID (左边列表)
    leftDataStoreName: 'SG_C_SA_STORE_ENAME', // 发货仓取值字段 - name (左边列表)
    shippingStock: '/api/cs/sg/storage/queryShareStorageByPro', // 查发货仓库存
    receivingStock: '/api/cs/sg/storage/queryShareStoreStorageByPro', // 查收货仓库存
    shareStoreidKey: 'takeStock', // shareStoreid 对应取值
    shareidKey: 'distribId', // shareid 对应取值
    paramsNoStore: true, // 接口报："店仓ID错误，找不到该店仓" 时,/api/cs/md/matrix 接口不传 CP_C_STORE_ID 这个入参
    delUrl: '/api/cs/sg/prodel', // 删除接口指定地址
    isUpdateDiscountBtn: false, // 是否有修改折扣按钮
    matchData: {},
    hideCommodityInput: true, // 商品编码输入框是否隐藏  分货单的不要显示
    hasMatch: false, // 是否有匹配矩阵
    hideInStock: true, // 是否隐藏在库（发货在库、收货在库）
    noZeroShwoFlag: true,
    hasStock: true, // 获取库存接口
    isStock: false, // 配置默认显示在库的还是可用的
    inputList: [{
      name: t('数量'),
      colname: 'QTY',
      defnum: 1
    }], // 配的数量字段名集合
    matrixInput: false, // 是否显示数量框
    hasReceiving: true, // 是否显示收货在库和可用
    hasQtyPrein: false, // 是否显示收货在途数量
    hasRetail: false // 是否显示零售数量
  }, // 分货单
  SG_B_STO_OTHER_DELIVERY: {
    getBody: '/api/cs/sg/getMatrixData', // 获取商品编码各个SKU数量（用于修改）
    amendBody: '/p/cs/objectSave', // 保存修改的商品编码各个SKU数量
    singleCode: '/p/cs/barcodeSave', // 单条码数量保存
    tableName: 'SG_B_STO_OTHER_DELIVERY_ITEM', // 子表表名 -
    queryObjSave: 'SG_B_STO_OTHER_DELIVERY_ITEM_PRO', // 左边列表保存字段名
    virtualName: 'SG_B_STO_OTHER_DELIVERY_ITEM_PRO', // 虚表表名
    isDeleteBtn: true, // 是否有删除明细按钮
    delUrl: '/api/cs/sg/prodel', // 删除接口指定地址
    isUpdateDiscountBtn: false, // 是否有修改折扣按钮
    matchData: {},
    receivingWarehouse: 'CP_C_STORE_ID', // 收货仓取值字段 (主表)
    paramsNoStore: true, // /api/cs/md/matrix 接口不传 CP_C_STORE_ID 这个入参
    hasMatch: false, // 是否有匹配矩阵
    noZeroShwoFlag: true,
    hasStock: false, // 获取库存接口
    isStock: false, // 配置默认显示在库的还是可用的
    inputList: [{
      name: t('数量'),
      colname: 'QTY',
      defnum: 1
    }], // 配的数量字段名集合
    matrixInput: false, // 是否显示数量框
    hasReceiving: true, // 是否显示收货在库和可用
    hasQtyPrein: false, // 是否显示收货在途数量
    hasRetail: false // 是否显示零售数量
  }, // 其他入库单
  SG_B_STO_OTHER_OUT_RESULT: {
    getBody: '/api/cs/sg/getMatrixData', // 获取商品编码各个SKU数量（用于修改）
    amendBody: '/p/cs/objectSave', // 保存修改的商品编码各个SKU数量
    singleCode: '/p/cs/barcodeSave', // 单条码数量保存
    tableName: 'SG_B_STO_OTHER_OUT_RESULT_ITEM', // 子表表名 -
    queryObjSave: 'SG_B_STO_OTHER_OUT_RESULT_ITEM_PRO', // 左边列表保存字段名
    virtualName: 'SG_B_STO_OTHER_OUT_RESULT_ITEM_PRO', // 虚表表名
    isDeleteBtn: true, // 是否有删除明细按钮
    delUrl: '/api/cs/sg/prodel', // 删除接口指定地址
    isUpdateDiscountBtn: false, // 是否有修改折扣按钮
    matchData: {},
    receivingWarehouse: 'CP_C_STORE_ID', // 收货仓取值字段 (主表)
    paramsNoStore: true, // /api/cs/md/matrix 接口不传 CP_C_STORE_ID 这个入参
    hasMatch: false, // 是否有匹配矩阵
    noZeroShwoFlag: true,
    hasStock: false, // 获取库存接口
    isStock: false, // 配置默认显示在库的还是可用的
    inputList: [{
      name: t('数量'),
      colname: 'QTY',
      defnum: 1
    }], // 配的数量字段名集合
    matrixInput: false, // 是否显示数量框
    hasReceiving: true, // 是否显示收货在库和可用
    hasQtyPrein: false, // 是否显示收货在途数量
    hasRetail: false // 是否显示零售数量
  }, // 其他出库单
  SG_B_SHARE_SA_TRANSFER: {
    getBody: '/api/cs/sg/getMatrixData', // 获取商品编码各个SKU数量（用于修改）
    amendBody: '/p/cs/objectSave', // 保存修改的商品编码各个SKU数量
    singleCode: '/p/cs/barcodeSave', // 单条码数量保存
    tableName: 'SG_B_SHARE_SA_TRANSFER_ITEM', // 子表表名 -
    queryObjSave: 'SG_B_SHARE_SA_TRANSFER_ITEM', // 左边列表保存字段名
    virtualName: 'SG_B_SHARE_SA_TRANSFER_ITEM_V', // 虚表表名
    isDeleteBtn: true, // 是否有删除明细按钮
    shippingWarehouse: 'SENDER_SA_STORE_ID', // 发货仓取值字段 (主表)
    receivingWarehouse: 'RECEIVER_SA_STORE_ID', // 收货仓取值字段 (主表)
    // leftDataStoreId: 'SG_C_SA_STORE_ID', // 发货仓取值字段 - ID (左边列表)
    // leftDataStoreName: 'SG_C_SA_STORE_ECODE', // 发货仓取值字段 - name (左边列表)
    shippingStock: '/api/cs/sg/storage/queryShareStoreStorageByPro', // 查发货仓库存
    receivingStock: '/api/cs/sg/storage/queryShareStoreStorageByPro', // 查收货仓库存    -- 配销仓调拨单   收货 发货 都是   p/cs/sg/storage/queryShareStoreStorageByPro 这个接口
    paramsNoStore: true, // 接口报："店仓ID错误，找不到该店仓" 时,/api/cs/md/matrix 接口不传 CP_C_STORE_ID 这个入参
    delUrl: '/api/cs/sg/prodel', // 删除接口指定地址
    isUpdateDiscountBtn: false, // 是否有修改折扣按钮
    matchData: {},
    hasMatch: false, // 是否有匹配矩阵
    hideInStock: true, // 是否隐藏在库（发货在库、收货在库）
    noZeroShwoFlag: true,
    hasStock: true, // 获取库存接口
    isStock: false, // 配置默认显示在库的还是可用的
    inputList: [{
      name: t('数量'),
      colname: 'QTY',
      defnum: 1
    }], // 配的数量字段名集合
    matrixInput: false, // 是否显示数量框
    hasReceiving: true, // 是否显示收货在库和可用
    hasQtyPrein: false, // 是否显示收货在途数量
    hasRetail: false // 是否显示零售数量
  }, // 配销仓调拨单
  SC_B_STORAGE_ADJUST: {
    getBody: '/api/cs/sg/getMatrixData', // 获取商品编码各个SKU数量（用于修改）
    amendBody: '/p/cs/objectSave', // 保存修改的商品编码各个SKU数量
    singleCode: '/p/cs/barcodeSave', // 单条码数量保存
    tableName: 'SC_B_STORAGE_ADJUST_ITEM', // 子表表名
    queryObjSave: 'SC_B_STORAGE_ADJUST_ITEM', // 左边列表保存字段名
    virtualName: 'SC_B_STORAGE_ADJUST_ITEM_V', // 虚表表名
    isDeleteBtn: true, // 是否有删除明细按钮
    matchData: {},
    hasMatch: false, // 是否有匹配矩阵
    hasStock: true, // 获取库存接口
    isStock: true, // 配置默认显示在库的还是可用的
    inputList: [{
      name: t('数量'),
      colname: 'QTY',
      defnum: 1
    }], // 配的数量字段名集合
    matrixInput: false, // 是否显示数量框
    hasReceiving: false,
    shippingWarehouse: 'CP_C_STORE_ID', // 发货仓取值字段 (主表)
  }, // 库存调整单
}
export default Object.assign({}, port, inventoryCenterPort);
